import { api } from '@smena/ui';

export interface AdminUser {
  id: string;
  email: string;
  name: string;
}

export async function fetchMe(): Promise<AdminUser> {
  const r = await api<{ user: AdminUser }>('/api/admin/auth/me');
  return r.user;
}

/** code - 6-значный TOTP из аутентификатора, обязателен (ADR-18). */
export async function login(input: {
  email: string;
  password: string;
  code: string;
}): Promise<AdminUser> {
  const r = await api<{ user: AdminUser }>('/api/admin/auth/login', { method: 'POST', json: input });
  return r.user;
}

export async function logout(): Promise<void> {
  await api('/api/admin/auth/logout', { method: 'POST' });
}
